import { connect } from 'react-redux';
import Realization from '../../../../views/Finance/Budgeting/Realization/Realization.finance.view';
import { getRealization, deleteRealization } from '../../../../states/thunks/finance.thunk';
import { getBudgetRealization } from '../../../../states/thunks/report.thunk';

function mapStateToProps(state) {
  return {
    user: state.user,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    handleGetRealization: payload => dispatch(getBudgetRealization(payload)),
    handleDeleteRealization: payload => dispatch(deleteRealization(payload)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Realization);
